<template>
  <div class="spinner-container">
    <h4 v-if="hasText" class="is-title is-size-4 loading-title">{{ $t("general.loading") }}</h4>
    <div class="m_spinner"></div>
  </div>
</template>

<script>
export default {
  props: {
    hasText: { type: Boolean, default: true },
  },
}
</script>

<style lang="scss" scoped>
.spinner-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 24px 0;
}

.loading-title {
  margin-bottom: 3rem;
}

.m_spinner {
  position: relative;
  width: 125px;
  height: 125px;
  -webkit-animation: spinner infinite 1.25s linear;
  -moz-animation: spinner infinite 1.25s linear;
  -o-animation: spinner infinite 1.25s linear;
  animation: spinner infinite 1.25s linear;
  border: 6px solid rgba(0, 0, 0, 0.1);
  border-left-color: #8050be91;
  border-radius: 142px;
}

@keyframes spinner {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
